import { render, staticRenderFns } from "./ConnectTable.vue?vue&type=template&id=2c4f1f31&"
import script from "./ConnectTable.js?vue&type=script&lang=js&"
export * from "./ConnectTable.js?vue&type=script&lang=js&"
import style0 from "./ConnectTable.vue?vue&type=style&index=0&id=2c4f1f31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports